<template>
<div class="bg">
  <a-card :title="$t('edit.editActionTitles.adsSets')" :bordered="false">
    <!--開場封面-->
    <span class="titles">{{$t('enum.covers.4')}}
      <a-icon class="ant-icon" type="down-square" />
    </span>
    <div class="advert-list-box">
      <div class="list-items">
        <AdsItem
                :url="form.cover.pc"
                requireSize="1920 x 1080"
                :title="$t('enum.covers.2')"
                :isEdit="(!userConfig || +userConfig.edit_cover === 1 ) && (userInfo.level > 0 || userInfo.team_id > 0)"
                @updateData="updatePCCover"
                @deleteData="deletePcCover"
        ></AdsItem>
      </div>
      <div class="list-items">
        <AdsItem
                :url="form.cover.mob"
                requireSize="480 x 800"
                :title="$t('enum.covers.3')"
                :isEdit="(!userConfig || +userConfig.edit_cover === 1 ) && (userInfo.level > 0 || userInfo.team_id > 0)"
                @updateData="updateMbCover"
                @deleteData="deleteMbCover"
        ></AdsItem>
      </div>
    </div>
    <div class="hr"></div>
    <!--公司信息-->
    <span class="titles">{{$t('edit.settings.companyInfo')}}
      <a-icon class="ant-icon" type="down-square" />
    </span>
    <div class="advert-list-box">
      <div class="list-items">
        <AdsItem
                :url="form.logo"
                requireSize="200 x 200"
                :title="$t('edit.settings.companyLogo')"
                :isEdit="(!userConfig || +userConfig.edit_logo_fix === 1) && (userInfo.level > 0 || userInfo.team_id > 0)"
                @updateData="updateLogo"
                @deleteData="deleteLogo"
        ></AdsItem>
      </div>
      <div class="list-items">
        <AdsItem
                :inputValue="form.author"
                @updateData="updateAuthName"
                :isEdit="!userConfig || +userConfig.edit_logo_fix === 1"
                frame-type="input"
                :title="$t('edit.settings.authName')"
        ></AdsItem>
      </div>
    </div>
    <div class="hr"></div>
    <!--其他（滾動文字）-->
    <span class="titles">{{$t('edit.settings.other')}}
      <a-icon class="ant-icon" type="down-square" />
    </span>
    <div class="advert-list-box">
      <div class="list-items full">
        <AdsItem
                :inputValue="form.top_ad"
                @updateData="updateTopAd"
                :isEdit="!userConfig || +userConfig.edit_top_ad === 1"
                frame-type="textarea"
                :title="$t('edit.settings.scrollTxt')"
                width="100%"
        ></AdsItem>
      </div>
    </div>
    <div class="hr"></div>
    <a-row>
      <a-col span="8">
        <a-form-model layout="vertical" ref="ruleForm" :form="form" :rules="rules" :model="form">
          <a-form-model-item>
            <a-button type="primary" @click="handleSubmit">{{$t('actionTitles.submit')}}</a-button>
            <a-button style="margin-left: 10px;">{{$t('actionTitles.cancel')}}</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
  </a-card>
</div>
</template>

<script>
import AdsItem from "./AdsItem";
import {
  mapGetters
} from "vuex";

export default {
  components: {
    AdsItem
  },
  computed: {
    ...mapGetters(["vrbase", "userConfig",'userInfo'])
  },
  data() {
    return {
      form: {
        author: '',
        cover: {
          pc: "",
          mob: "",
        },
        logo: "http://qiniu.vipyun.vip/1812/works/7510212bb95f1259/thumb.jpg",
        fix_logo: {
          land: "",
          sky: "",
        },
        bgm: "http://oss.wa720.com/1/media/msc/b62bce80247fe9b6.mp3",
        bgv: "",
        top_ad: "",
      },
      rules: {},
    };
  },
  created() {
    this.form = this.$deepClone(this.vrbase.ads);
    if(!this.form.author){
      this.form.author = this.userInfo.name;
    }
    console.log('userConfig',this.userConfig)
  },
  methods: {
    updatePCCover(data) {
      this.form.cover.pc = data.url;
    },
    deletePcCover() {
      this.form.cover.pc = ''
    },
    updateMbCover(data) {
      this.form.cover.mob = data.url;
    },
    deleteMbCover() {
      this.form.cover.mob = ''
    },
    updateLogo(data) {
      this.form.logo = data.url;
    },
    deleteLogo() {
      this.form.logo = ''
    },
    updateAuthName(data){
      this.form.author = data
    },
    updateTopAd(value) {
      this.form.top_ad = value
    },
    handleSubmit() {
      // this.$store.dispatch()
      this.$refs.ruleForm.validate((valid) => {
        const vrbase = {...this.vrbase, ads: this.form,}
        if (valid) {
          this.$store.dispatch("saveVRBase", {
            vrbase,
            showLoading: true,
          }, true);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  .submitBtn {
    background-color: #7101ad;
    border-color: #7101ad;
  }

  .titles {
    font-size: 16px;

    .ant-icon {
      font-size: 14px;
      color: rgba(255, 255, 255, .6);
      margin-left: 6px;
    }
  }

  .hr {
    width: 100%;
    height: 2px;
    border-top: 1px solid rgb(0, 0, 0);
    border-bottom: 1px solid rgb(75, 75, 75);
    margin: 30px 0;
  }
  .advert-list-box {
    max-width: 900px;
    overflow: hidden;
    padding-left: 20px;
    .list-items {
      float: left;
      width: 50%;
      &.full{
        width: 100%;
      }
    }
  }
}
</style>
